import React, { type FC } from 'react'
import Snackbar from '@mui/material/Snackbar'

import { type Message } from '../../../redux/messages/messages-types'
import { AcknowledgeMessageAction } from '../../../redux/messages/messages-actions'
import { Alert } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { type TFunction } from 'i18next'
import { useAppDispatch, useAppSelector } from '../../../redux/hooks'
import { type RootState } from '../../../redux/store'

const MSG_AUTO_CLOSE_DELAY_MS = 10_000

/**
 * Toast component for displaying messages.
 */
export const Toasts: FC = () => {
  const dispatch = useAppDispatch()
  const messages = useAppSelector<Message[]>((state: RootState) => state.messages.messages)

  const onClose = (message: Message): void => {
    dispatch(AcknowledgeMessageAction({ id: message.id }))
  }

  return (
        <>
            {messages.map(message =>
                <MessageRow key={message.id} message={message} onClose={onClose}/>
            )}
        </>
  )
}

/* Child-components */

interface MessageRowProps {
  message: Message
  onClose: (message: Message) => void
}

function MessageRow({ message, onClose }: Readonly<MessageRowProps>): React.ReactElement {
  const { t } = useTranslation()

  return (
        <Snackbar
            open={true}
            autoHideDuration={MSG_AUTO_CLOSE_DELAY_MS}
            onClose={() => {
              onClose(message)
            }}
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'center'
            }}
        >
            <Alert onClose={() => {
              onClose(message)
            }} severity={message.type} sx={{
              width: '100%',
              alignItems: 'center',
              fontSize: 'large'
            }}>
                {getMessageText(message, t)}
            </Alert>
        </Snackbar>)
}

/* Helper Functions */

function getMessageText(msg: Message, t: TFunction): string {
  return msg.literalMessage === true ? msg.message : t(msg.message)
}
